$(document).ready(function() {
	function findFirst(element) {
		if ($(element).first().length) {
			return true;
		} else {
			return false;
		}
	}

    $(".carousel").on("slid.bs.carousel", function(event) {
        // we need this to suppress jumping to anchor after sliding on iOS
        event.preventDefault();
	});

	// shows/hides selected/unselected container, works nested too
	$(".tab-container").each(function() {
		$(this).find("a[data-tab-target]").on("click", function() {
			var cParent = $(this).closest(".tab-container");
			var cTarget = $(this).attr("data-tab-target");
			var allTabs = $(cParent).find(".tab");
			$(cParent).find("a[data-tab-target]").removeClass("active");
			$(this).addClass("active");
			$(allTabs).addClass("hide").filter("." + cTarget).removeClass("hide");
		})
	});

	// gaming results page
	if (findFirst(".page-gaming-results")) {
		var gameContainer = $(this).find("#gameType-container");
		var dateContainerLotto = $(this).find("#date-lotto");
		var dateContainerEurojackpot = $(this).find("#date-eurojackpot");
		var dateLinksLotto = dateContainerLotto.find(".date");
		var dateLinksEurojackpot = dateContainerEurojackpot.find(".date");
		
		$(this).find("a[data-tab-target]").on("click", function() {
			var gameType = $(this).data("tab-target");
			var cTarget = $(this).attr("data-tab-target");
			var allTabs = $(gameContainer).find(".tab");

			$('#drawings').attr('action', window.location.origin + "/gewinnzahlen/" + gameType + "/");

			$(gameContainer).find("a[data-tab-target]").removeClass("active");
			$(this).addClass("active");
			$(allTabs).addClass("hide").filter("." + cTarget).removeClass("hide");
		});

		// tab navigation, remove highlight class on other tabs
		dateContainerLotto.find("#custom-date-lotto").on("click", function() {
			dateLinksLotto.removeClass("active");
		});
		dateContainerEurojackpot.find("#custom-date-eurojackpot").on("click", function() {
			dateLinksEurojackpot.removeClass("active");
		});
	}
	
	var isPageLottoQuicktipp = findFirst(".page-lotto-quicktipp");
	var isPageEurojackpotQuicktipp = findFirst(".page-eurojackpot-quicktipp");
	
	/*#region quicktipp*/
	if (isPageLottoQuicktipp || isPageEurojackpotQuicktipp) {

		var refreshQuicktippTotalAmount = null;
		var maxRows = null;
		var gameType = null;

		if(isPageLottoQuicktipp) {
			refreshQuicktippTotalAmount = refreshLottoQuicktippTotalAmount;
			maxRows = 12;
			gameType = "lotto";
		} else {
			refreshQuicktippTotalAmount = refreshEurojackpotQuicktippTotalAmount;
			maxRows = 8;
			gameType = "eurojackpot";
		}
		
		refreshQuicktippTotalAmount();

		var spielscheinEinstellungen = $("#spielschein-einstellungen");
		var buttonSpielscheinToBasketModal = $("#modal-btn-submit");
		var formQuicktippEurojackpot = $("#eurojackpot-quicktipp");
		var radioBtnProductSubscription = spielscheinEinstellungen.find('#input-productSubscription');
		var radioBtnNonProductSubscription = spielscheinEinstellungen.find('#input-nonSubscription');
		var radioBtnJackpotHunter = spielscheinEinstellungen.find('#input-jackpot-hunter');
		var radioBtnJackpotAbo = spielscheinEinstellungen.find('#input-jackpot-abo');
		var containerWochenlaufzeit = spielscheinEinstellungen.find("#laufzeit");
		var advantagesListSub = radioBtnProductSubscription.nextAll(".list-advantages:first");
		var advantagesListNonSub = radioBtnNonProductSubscription.nextAll(".list-advantages:first");
		var radioBtnGrpSubscriptionSelection = updateWeekDurationContainer(radioBtnProductSubscription, radioBtnNonProductSubscription, radioBtnJackpotHunter, radioBtnJackpotAbo, containerWochenlaufzeit, advantagesListSub, advantagesListNonSub);
		var radioBtnSpieltag = spielscheinEinstellungen.find("#spieltage").find("input[type='radio']");

		var radioBtnGrpIsProductSubscription = spielscheinEinstellungen.find('input[type=radio][name="isProductSubscription"]');
		var laufzeitContainer = spielscheinEinstellungen.find("#laufzeit");
		var buttonsParticipationPeriod = spielscheinEinstellungen.find(".participation-period");
		var submitBtn = spielscheinEinstellungen.find("#button-to-basket");

		var containerSpielscheinInfo = spielscheinEinstellungen.find("#spielschein-info");
		var containerMissingSelection = spielscheinEinstellungen.find("#missing-selection");
		var containerInfoRowCount = spielscheinEinstellungen.find("#info-row-count");
		var containerInfoDuration = spielscheinEinstellungen.find("#info-duration");
		var containerInfoDates = spielscheinEinstellungen.find("#info-dates");
		
		var spielReihen = spielscheinEinstellungen.find("#spiel-reihen");
		var reihenContainer = spielscheinEinstellungen.find(".reihe-container");
		var currentReihenContainer = "";
		var titleRowCountContainer = spielscheinEinstellungen.find("#title-row-count");
		var inputRows = $("#rows");

		// lotto
		var containerInfoExtraGames = spielscheinEinstellungen.find("#info-extra-games");
		var checkboxSpiel77 = spielscheinEinstellungen.find("#input-spiel77");
		var checkboxSuper6 = spielscheinEinstellungen.find("#input-super6");
		var radioBtnGrpSpieltage = spielscheinEinstellungen.find('input[type=radio][name="drawing_day"]');

		// eurojackpot
		var dateTimeStrings = null;

		if(isPageLottoQuicktipp) {
			updateInfoExtraGamesContainer(containerInfoExtraGames, checkboxSpiel77.prop("checked"), checkboxSuper6.prop("checked"), spielReihen.data("rows"));
			dateTimeStrings = spielscheinEinstellungen.find('input[type=radio][name="drawing_day"]:checked').attr("data-date");
		} else {
			dateTimeStrings = typeof spielscheinEinstellungen.find('input[type=radio][name="drawing_day"]:checked').attr("data-date") !== "undefined" ?  spielscheinEinstellungen.find('input[type=radio][name="drawing_day"]:checked').attr("data-date") : containerSpielscheinInfo.data("dates");
		}

		var drawingDate = "";
		var deadline = "";
		var participation = "";

		updateDates(dateTimeStrings);
		updateRowCountTitleContainer(titleRowCountContainer, spielReihen.data("rows"), maxRows);
		updateInfoRowCountContainer(containerInfoRowCount, spielReihen.data("rows"), gameType);
		updateInfoDatesContainer(containerInfoDates, drawingDate, deadline, participation);

		updateSpielscheinToBasketButton(submitBtn, radioBtnGrpIsProductSubscription, radioBtnGrpSubscriptionSelection);

		// on click row count buttons
		reihenContainer.click(function (event)
		{
			if(currentReihenContainer.length) {
				currentReihenContainer.removeClass("selected");
				currentReihenContainer = $(this);
				currentReihenContainer.addClass("selected");
				
			} else {
				reihenContainer.first().removeClass("selected");
				currentReihenContainer = $(this);
				currentReihenContainer.addClass("selected");
			}
			
			spielReihen.data("rows", $(this).index() + 1);
			inputRows.val(spielReihen.data("rows"));

			updateInfoRowCountContainer(containerInfoRowCount, spielReihen.data("rows"), gameType);

			updateRowCountTitleContainer(titleRowCountContainer, spielReihen.data("rows"), maxRows);
			refreshQuicktippTotalAmount();
		});

		// On change radio button group "Dauerschein" / "Einzelschein"
		radioBtnGrpIsProductSubscription.on("change", function (event) {
			console.log("on.change -> subscription/dauerschein radiobuttons");
			var advantagesLists = $(".list-advantages");
			advantagesLists.addClass("disabled");
			advantagesLists.show();
			advantagesListSub.removeClass("shrink-height");
			$("#jackpot-million").hide();
			
			radioBtnGrpSubscriptionSelection = updateWeekDurationContainer(radioBtnProductSubscription, radioBtnNonProductSubscription, radioBtnJackpotHunter, radioBtnJackpotAbo, containerWochenlaufzeit, advantagesListSub, advantagesListNonSub);
			
			if(radioBtnGrpSubscriptionSelection == 3 || radioBtnGrpSubscriptionSelection == 4) {
				radioBtnSpieltag.prop("disabled", true);
			} else {
				radioBtnSpieltag.prop("disabled", false);
			}

			updateInfoDurationContainer(containerInfoDuration, radioBtnGrpSubscriptionSelection, laufzeitContainer.data("duration"));

			updateSpielscheinToBasketButton(submitBtn, radioBtnGrpIsProductSubscription, radioBtnGrpSubscriptionSelection);
		});

		// on click week duration buttons
		buttonsParticipationPeriod.click(function () {
			laufzeitContainer.data("duration",  $(this).attr("data-participation-period"));
			$("#laufzeit").data("selected-duration", $(this).attr("data-participation-period"));

			$("#duration").val($(this).attr("data-participation-period"));
			updateInfoDurationContainer(containerInfoDuration, radioBtnGrpSubscriptionSelection, laufzeitContainer.data("duration"));
			refreshQuicktippTotalAmount();
		});

		if(isPageLottoQuicktipp) {
			(checkboxSpiel77).add(checkboxSuper6).click(function() {
				updateInfoExtraGamesContainer(containerInfoExtraGames, checkboxSpiel77.prop("checked"), checkboxSuper6.prop("checked"), spielReihen.data("rows"));
				refreshQuicktippTotalAmount();
			});
		}

		radioBtnGrpSpieltage.on("change", function (event) {
			var drawingDay = $(this).attr("data-label");
			var dateTimeStrings = $('input[type=radio][name="drawing_day"]:checked').attr("data-date");

			// display correct winning plan text
			displayWinningPeriodText(drawingDay);

			// update participation period settings
			if (isPageLottoQuicktipp && typeof customLottoTicketSettings != "undefined") {
				updateParticipationPeriods(drawingDay, laufzeitContainer, buttonsParticipationPeriod);
			}

			$("#spieltage").data("selected-day", $(this).attr("data-label"));
			updateDates(dateTimeStrings);
			updateInfoDatesContainer(containerInfoDates, drawingDate, deadline, participation);
			refreshQuicktippTotalAmount();
		});

	};

	if(isPageEurojackpotQuicktipp) {
		submitBtn.on("click", function(e) {
			console.log("OnSubmitEJQuicktipp");
			// executed at new EJ date?
			let drawingDateJS = new Date(drawingDate.split('.').reverse().join('-'));
			let numWeeks = laufzeitContainer.data("duration");
			
			// we don't want to add the first week here (-1)
			drawingDateJS.setDate(drawingDateJS.getDate() + (7 * (numWeeks -1)));
			let exceedsDateNewEJ = drawingDateJS > ejTuesdayDrawingDate;
			
			// debug 12DigitsForEJSecondRowDate compare
			console.log("FirstDrawingDate + Weeks: " + drawingDateJS);
			console.log("Last Tuesday before new EJ Friday (22.03. prod) = " + ejTuesdayDrawingDate);
			console.log("First drawing >= new EJ Friday = " + exceedsDateNewEJ);
			console.log("display modal at current date? " + showNewEJModal);

			// duration exceeds last old EJ drawing day?
			if(exceedsDateNewEJ && showNewEJModal) {
				$("#modal-new-ej").modal("show");

				return;
			} else {
				$(this).prop("disabled", true);
				
				formQuicktippEurojackpot.submit();
			}			
		});

		/**
		 *  @description Add Eventhandler to button "buttonSpielscheinToBasketModal"
		 */
			buttonSpielscheinToBasketModal.on("click", function(e) {
			$(this).prop("disabled", true);
			
			formQuicktippEurojackpot.submit();
			});
	}

	/**
	 * @description Updates submit Button 'disabled' state
	 */
	 function updateSpielscheinToBasketButton(submitBtn, radioBtnGrpIsProductSubscription, radioBtnGrpSubscriptionSelection) {
		console.log("updateSpielscheinToBasketButton");

		// enable 'into basket' button, once user selected 'pos' or 'nonPos'
		var posRadioChecked = radioBtnGrpSubscriptionSelection != 0;

		if (posRadioChecked) {
			submitBtn.prop("disabled", false);
		} else {
			submitBtn.prop("disabled", true);
		}
	}

	function updateRowCountTitleContainer(titleRowCountContainer, rowCount, maxRowCount) {
		titleRowCountContainer.html("(" + rowCount + " von " + maxRowCount + " ausgewählt)");
	}

	function updateParticipationPeriods(drawingDay, laufzeitContainer, buttonsParticipationPeriod) {
		var allowedDurationInWeeks = customLottoTicketSettings[drawingDay];

		// hide or show participation period button
		for (var i=1; i<=5; i++) {
			if(allowedDurationInWeeks >= i) {
				buttonsParticipationPeriod.filter('[data-participation-period="' + i + '"]').show();
			} else {
				buttonsParticipationPeriod.filter('[data-participation-period="' + i + '"]').hide();
			}
		}

		// set participation period value "1" active
		if (customLottoTicketSettings[drawingDay] < laufzeitContainer.data("duration")) {
			laufzeitContainer.data("duration", customLottoTicketSettings[drawingDay]);
		}

		buttonsParticipationPeriod.removeClass("active").filter('[data-participation-period="' + laufzeitContainer.data("duration") + '"]').addClass("active");
	}

	/**
	 * @description Update "Annahmeschluss" and "Erste Teilname" dates.
	 * 				Converts input date to native js
	 *
	 * @returns void
	 */
	function updateDates(dateTimeStrings) {
		var arrDate = dateTimeStrings.split(",");

		drawingDate =arrDate[0];
		deadline = arrDate[1];
		participation = arrDate[2];
	}

	/*#endregion quicktipp*/

	// Community page
	if (findFirst(".page-community")) {
		let currentRadioBtnGroupIsPosSpge = null;
		let currentFormSpge = null;

		$(".spge-product").each(function(index) {
			let spgeProductContainer = $(this);
			let submitBtnSpge = spgeProductContainer.find(".submit-btn-spge");
			let radioBtnGroupIsPosSpge = spgeProductContainer.find('input[type=radio][name="isProductSubscription"]');
			let ticketrows = spgeProductContainer.find('input[type=hidden][name="ticketrows"]');
			let maxSpgeCount = spgeProductContainer.find('input[type=hidden][name="maxSpgeCount"]');
			let maxSpgeParts = spgeProductContainer.find('input[type=hidden][name="maxSpgeParts"]');
			let participations = spgeProductContainer.find('input[type=hidden][name="participations"]');
			let formSpge = spgeProductContainer.find(".form-spge");
			let radioBtnGroupIsJackpotAbo = spgeProductContainer.find('.input-jackpot-abo');
			let selectJackpotAboMinValue = spgeProductContainer.find('.select-jackpotAboMinValue');
			let spgeAmountMinus = spgeProductContainer.find('.spge-amount .minus-sign');
			let spgeAmountPlus = spgeProductContainer.find('.spge-amount .plus-sign');
			let spgeQuantityMinus = spgeProductContainer.find('.spge-quantity .minus-sign');
			let spgeQuantityPlus = spgeProductContainer.find('.spge-quantity .plus-sign');
			let itemCount = spgeProductContainer.find('.item-count');			
			let quantityCount = spgeProductContainer.find('.quantity-count');
			let itemCountDsp = spgeProductContainer.find('.item-count-dsp');			
			let quantityCountDsp = spgeProductContainer.find('.quantity-count-dsp');
			let price = spgeProductContainer.find('.spgePrice');

			let successfactor = spgeProductContainer.find('.successfactor');
			let totalrows = spgeProductContainer.find('.totalrows');
			let topprofit = spgeProductContainer.find('.topprofit');
			let topquantity = spgeProductContainer.find('.topquantity');

			let triggerModalSpge = !radioBtnGroupIsPosSpge.prop('checked');
			let modalGameType = $(this).data("game-type");
			let priceMultiplicator = 1;
			let newPrice = 0;

			spgeAmountMinus.click(function( event ) {
				setMultiplicator('amount', itemCount, itemCountDsp, -1);
			});

			spgeAmountPlus.click(function( event ) {
				setMultiplicator('amount', itemCount,itemCountDsp, 1);
			});

			spgeQuantityMinus.click(function( event ) {
				setMultiplicator('quantity', quantityCount, quantityCountDsp, -1);
			});

			spgeQuantityPlus.click(function( event ) {
				setMultiplicator('quantity', quantityCount, quantityCountDsp, 1);
			});

			itemCount.on("input", function() {
				calculateDynamicValues();
			});

			quantityCount.on("input", function() {
				calculateDynamicValues();
			});

			radioBtnGroupIsPosSpge.on("change", function (event) {
				triggerModalSpge = false;

				if(radioBtnGroupIsJackpotAbo.prop('checked')) {
					selectJackpotAboMinValue.show();
				} else {
					selectJackpotAboMinValue.hide();
				}
			});

			submitBtnSpge.click(function( event ) {
				// set current values for modal
				currentRadioBtnGroupIsPosSpge = radioBtnGroupIsPosSpge;
				currentFormSpge = formSpge;

				if (triggerModalSpge) {
					let classes = "theme-" + modalGameType + " square";
					$("#input-productSubscription-reminder").attr('class', classes);
					$("#input-nonSubscription-reminder").attr('class', classes);
					$("#modal-pos").modal("show");
					console.log(modalGameType);
				} else {
					formSpge.submit();
				}
			});

			function setMultiplicator(type, el, elDsp, val) {
				let temp = parseInt(el.val()) + parseInt(val);

				if(temp < 1) {
					temp = 1;
				}

				if(type == 'amount') {
					if(temp >= maxSpgeCount.val()) {
						temp = maxSpgeCount.val();
						spgeAmountPlus.removeClass('active');
						spgeAmountPlus.addClass('inactive');
					} else {
						spgeAmountPlus.removeClass('inactive');
						spgeAmountPlus.addClass('active');						
					}

					if(temp > 1) {
						spgeAmountMinus.removeClass('inactive');
						spgeAmountMinus.addClass('active');
					} else {
						spgeAmountMinus.removeClass('active');
						spgeAmountMinus.addClass('inactive');
					}
				}

				if(type == 'quantity') {
					if(temp >= maxSpgeParts.val()) {
						temp = maxSpgeParts.val();
						spgeQuantityPlus.removeClass('active');
						spgeQuantityPlus.addClass('inactive');
					} else {
						spgeQuantityPlus.removeClass('inactive');
						spgeQuantityPlus.addClass('active');
					}

					if(temp > 1) {
						spgeQuantityMinus.removeClass('inactive');
						spgeQuantityMinus.addClass('active');
					} else {
						spgeQuantityMinus.removeClass('active');
						spgeQuantityMinus.addClass('inactive');
					}
				}

				el.val(temp);
				elDsp.html(temp);
				calculateDynamicValues();
			}

			function calculateDynamicValues() {
				let tempProfit = "Fehler";
				let successText = "";
				let quantityText = "";

				if(modalGameType == "lotto") {
					tempProfit = lottoJackpot / participations.val() * quantityCount.val();
				} else if (modalGameType == "eurojackpot") {
					tempProfit = euroJackpot / participations.val() * quantityCount.val();
				}

				switch(itemCount.val()) {
					case '1':
						successText = "Starkes Spiel mit";
					break;

					case '2':
						successText = "Doppelte Chancen mit";
					break;

					default:
						successText = itemCount.val() + "-fache Chancen mit";
				}

				switch(quantityCount.val()) {
					case '1':
						quantityText = "Sie spielen einen von " + participations.val();
					break;

					case '2':
						quantityText = "Sie spielen zwei von " + participations.val();
					break;

					default:
						quantityText = "Sie spielen " + quantityCount.val() + " von " + participations.val();
				}

				successText += " <b>" + ticketrows.val() * itemCount.val() + "</b>";
				quantityText += " Anteilen";

				successfactor.html(successText);
				topquantity.html(quantityText);

				if(tempProfit >= 1000000) {
					tempProfit = (
							tempProfit / 1000000).toLocaleString('de-DE', {
							maximumFractionDigits: 3, 
							minimumFractionDigits: 3
						}
					);

					var leftRightValues = tempProfit.split(',');

					// 1090000,117 => 1 Mio. €
					if(leftRightValues[1] < 100) {
						tempProfit = leftRightValues[0];
					} else {
						tempProfit = leftRightValues[0] + "," + Math.floor(leftRightValues[1] / 100);
					}

					topprofit.html(tempProfit + " Millionen €");
				} else {
					tempProfit = Math.round(tempProfit * 10) / 10;
					topprofit.html(
						tempProfit.toLocaleString('de-DE', {
						style: 'currency',
						currency: 'EUR',
						maximumFractionDigits: 0, 
						minimumFractionDigits: 0
					}));
				}

				priceMultiplicator = itemCount.val() * quantityCount.val();
				newPrice = priceMultiplicator * price.attr("spgePrice");
				price.html((newPrice / 100).toFixed(2).replace(".", ",") + "&nbsp;€");
			}

			function calculateChances() {
				priceMultiplicator = itemCount.val() * quantityCount.val();
				newPrice = priceMultiplicator * price.attr("spgePrice");
				price.html((newPrice / 100).toFixed(2).replace(".", ",") + "&nbsp;€");
			}

		});

		$("#modal-btn-submit").click(function(event) {
			// get modal value
			let isPOS = $("#input-productSubscription-reminder").prop('checked');
			
			// sync actual form values with the modal ones
			currentRadioBtnGroupIsPosSpge.val([isPOS]);
			currentFormSpge.submit();
		});
	}

	$(".button-radio-toggle").on("click", function (event) {
		var buttonGroup = $(this).closest(".button-radio-group");
		buttonGroup.find(".button-radio-toggle").removeClass("active");
		$(this).addClass("active");
	});

	$("#scheinID").each(function() {
		$(this).spielschein({
			spielschein: meinSpielschein,
			spielSysteme: gebuehrenMatrix
		});

		if($(this).hasClass("lotto")) {
			localStorage["eurojackpotRefreshSpielscheinValues"] = 0;
			localStorage["systemscheinRefreshSpielscheinValues"] = 0;
		}

		if($(this).hasClass("eurojackpot")) {
			localStorage["lottoRefreshSpielscheinValues"] = 0;
			localStorage["systemscheinRefreshSpielscheinValues"] = 0;
		}

		if($(this).hasClass("systemschein")) {
			localStorage["lottoRefreshSpielscheinValues"] = 0;
			localStorage["eurojackpotRefreshSpielscheinValues"] = 0;
		}
	});

	if($("#scheinID").length == 0 ) {
		localStorage["lottoRefreshSpielscheinValues"] = 0;
		localStorage["eurojackpotRefreshSpielscheinValues"] = 0;
		localStorage["systemscheinRefreshSpielscheinValues"] = 0;
	}

	// Page: Zahlen und Quoten (/gaming/results)
	if (findFirst(".page-gaming-results")) {
		$("#lotto_drawing_year, #lotto_drawing_at, #eurojackpot_drawing_year, #eurojackpot_drawing_at").change(function() {
			$("form[name='drawings']").submit();
		})
	}

	/**
	 * @description restores data from localStorage
	 *
	 * @return void
	 */
	if (
		localStorage.getItem("faber_c") !== null
		|| localStorage.getItem("faber_l") !== null
	) {
		var dataC = localStorage.getItem("faber_c") === null ? "" : localStorage.getItem("faber_c");
		var dataL = localStorage.getItem("faber_l") === null ? "" : localStorage.getItem("faber_l");

		var data = {
			"dataL": dataL,
			"dataC": dataC,
		}

		$.ajaxHandler({
			"data": data,
			"url": "/ajax/restoreSession/",
			"callback_success": "successRestoreSession"
		});
    }

     // Close collapsed elements by clicking outsite
     $(document).click(function (e) {
		if ($(e.target).closest(".collapse.show").data("parent") != "#grp-nabar-icons") {
			$(".collapse[data-parent='#grp-nabar-icons']").collapse("hide");
        }
	});

	$(window).scroll(function() {
		if ($(this).scrollTop() > 200) {
			$('#scroll-to-top').fadeIn();
		} else {
			$('#scroll-to-top').fadeOut();
		}
	});
	// scroll body to 0px on click
	$('#scroll-to-top').click(function() {
		$('#scroll-to-top').tooltip('hide');
		$('body,html').animate({
			scrollTop: 0
		}, 500);
		return false;
	});

	if (
		findFirst(".page-register-create")
		|| findFirst(".page-change-password")
		|| findFirst(".page-user-forgot-password")
		|| findFirst(".page-service-profil")
	) {

		// Passwort Check
    	var options = {};
		options.ui = {
			container: "#pwd-container",
			viewports: {
				progress: ".pwstrength-viewport-progress"
			},
			showVerdictsInsideProgressBar: true,
		};
		options.common = {
			minChar: 8,
			usernameField: "email1"
		};

		$('#password1').pwstrength(options);

		// Dropdown
		$("select").select2({
			"language": {
				"noResults": function() {
					return "Keine Ergebnisse";
				}
			}
		});

		// Anrede
		$('#title').on('select2:closing', function () {
			var highlightedOption = $(this).data('select2').$dropdown.find('.select2-results__option--highlighted').attr('id');
			var idValues = highlightedOption.split('-');
			if(highlightedOption) {
				$("#title").val(idValues[idValues.length -1]).trigger('change');
			}
		});

		$("#same_birthName").on("click", function() {
			var isCheckedsameBirthName = $("#same_birthName").is(':checked');

			$('#birthname').attr("required", !isCheckedsameBirthName);

			if(isCheckedsameBirthName) {
				$("#birth_name").removeAttr('required');
				$("#birth_name").hide();
				$("#birthname").val("");
			} else {
				$("#birth_name").show();
				$("#birth_name").attr("required", "");
			}
		});

		initializeAddressBindings();

		// Birthday
		$('#birth_at_day').on('select2:closing', function () {
			var highlightedOption = $(this).data('select2').$dropdown.find('.select2-results__option--highlighted');
			if(highlightedOption) {
				$("#birth_at_day").val(highlightedOption.text()).trigger('change');
			}
		});

		$('#birth_at_month').on('select2:closing', function () {
			var highlightedOption = $(this).data('select2').$dropdown.find('.select2-results__option--highlighted').attr('id');
			var idValues = highlightedOption.split('-');
			if(highlightedOption) {
				$("#birth_at_month").val(idValues[idValues.length -1]).trigger('change');
			}
		});

		$('#birth_at_year').on('select2:closing', function () {
			var highlightedOption = $(this).data('select2').$dropdown.find('.select2-results__option--highlighted');
			if(highlightedOption) {
				$("#birth_at_year").val(highlightedOption.text()).trigger('change');
			}
		});

		$("#iban").focusout(function() {
            if(IBAN.isValid($(this).val())) {
                resultIban = $.ajaxHandler({
                    "data"              : {iban: $(this).val().replace(/\s/g, "")},
                    "url"               : "/ajax/getBankAccountDetailsByIBAN/",
                    "async" : false
				});

				if(resultIban.success) {
					console.log(resultIban.result.bankName);
					$("#bank_name").val(resultIban.result.bankName);
					$("#bank_name_text").text(resultIban.result.bankName);
				}
            } else {
				$("#bank_name").val('');
				$("#bank_name_text").val('');
			}
		});

	}

	if(findFirst(".page-bank-account")) {
		$("input[name='edit']").on("click", function() {
			var sIban = $("#iban").val().replace(/\s/g, "");
			if(sIban.indexOf("x") == -1 ) {
				if(IBAN.isValid(sIban)) {
				    resultIban = $.ajaxHandler({
				        "data"              : {iban: sIban},
				        "url"               : "/ajax/getBankAccountDetailsByIBAN/",
				        "async" : false
					});

					if(resultIban.success) {
						$("#bankname").html(resultIban.result.bankName);
						return true;
					}
				}
			}

			$(".invalid-feedback").show();
			$("#bankname").html("");

			return false;
		});
	}

	$(".btn-submit").click(function() {
		$(".alert").hide();
	});

	if(findFirst(".page-service-profil")) {
		var dropdownStreet = $("#street");
		if(dropdownStreet.find(":selected").text() == "Straße") {
			dropdownStreet.append($('<option>', {
				"value" 		: dropdownStreet.attr("data-current-value"),
				"text" 			: dropdownStreet.attr("data-current-value"),
				"selected"		: true
			}));
		}
	}

	if(findFirst(".page-service-cart")) {
		$(".btn-submit-voucher").on("click", function(e){
			if($("#coupon").val() != "") {
				e.preventDefault();
				$('#submitBasket').attr('action', $(this).data("url")).submit();
			}
		});
	}

	$(function() {
		$("[data-toggle='popover']").popover();
	});

	$("[data-toggle='popover']").click(function(e) {
		$("[data-toggle='popover']").not(this).popover("hide");
	});

	// close popover by clicking outside the popover
	$("html").on("click", function (e) {
		if (
			typeof $(e.target).data("original-title") == "undefined"
			&& $(e.target).data("toggle") !== "popover"
			&& $(e.target).parents("[data-toggle='popover']").length === 0
            && $(e.target).parents(".popover.in").length === 0
		) {
			$("[data-toggle='popover']").popover("hide");
		}
	});

	$(".close-verification-hint").on("click", function() {
		console.log('onclick auf close test');
		$.ajaxHandler({
			"data": {},
			"url": "/ajax/hideAccountVerificationHint/",
			"async": false
		});
	});

	$(".close-eventpromotion-hint").on("click", function() {
		console.log('onclick auf close eventpromotion test');
		$.ajaxHandler({
			"data": {},
			"url": "/ajax/hideEventPromotionNotification/",
			"async": false
		});
	});

	$(".close-customer-feedback").on("click", function() {
		console.log('onclick auf close-customer-feedback');

		$(".vote").hide();

		$.ajaxHandler({
			"data": {},
			"url": "/ajax/hideCampaignRequest/",
			"async": false
		});
	});

	$(".pw-show").on("click", function() {
		let input = $(this).prev("input");
		
		if(input.attr('type') == "password") {
			input.attr("type", "text");
		} else {
			input.attr("type", "password");
		}
	});

	// Format IBAN
	formatExistingIbanInputWidthID('iban');

	if (findFirst(".page-service-cart")) {
		$("#useCredit").change(function () {
			showPrice();
		});

		$('input:radio[name=payment_method]').change(function () {
			var activePaymentMethod = $('input[name=payment_method]:checked').val();

			if (activePaymentMethod == 'ueberweisung') {
				$('#useCredit').prop('checked', false);
				$('#useCredit').prop('disabled', true);
			} else if (activePaymentMethod == 'lastschrift') {
				$('#useCredit').prop('disabled', false);
				$('#useCredit').prop('checked', true);
			}

			showPrice();
		});

		function showPrice() {
			if($("#useCredit").is(":checked")) {
				$("#sumPrice").hide();
				$("#balancePrice").show();
				$("#creditSection").removeClass("diabledCreditOption");
				$(".icon-credit").removeClass("diabledCreditOption");
			} else {
				$("#sumPrice").show();
				$("#balancePrice").hide();
				$("#creditSection").addClass("diabledCreditOption");
				$(".icon-credit").addClass("diabledCreditOption");
			}
		}
	}
});

$(document).on('focus', '.select2', function() {
	jQuery(this).siblings('select').select2('open');
});

function displayWinningPeriodText(drawingDay) {
	var days = ["m", "s", "k"];
	var txtID = 0;

	$.each(days, function (index, day) {
		txtID = $("#winningPlan_" + day);

		if (day == drawingDay) {
			txtID.show();
		} else {
			txtID.hide();
		}
	});	
}

function formatExistingIbanInputWidthID(ibanInputID) {
	// Format IBAN
	var ibanInputField = document.getElementById(ibanInputID);
	if(ibanInputField) {
		console.log("Iban Format");
		ibanInputField.addEventListener('input', function (e) {
			e.target.value = e.target.value.toUpperCase();
			e.target.value = e.target.value.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
		});
	}
}

function setCookieConsentState(allowAll=false, allowSocial=false, allowAnalytics=false) {
	if(allowSocial && allowAnalytics) {
		allowAll = true;
	}

	var data = { allowAll:allowAll, allowSocial:allowSocial, allowAnalytics:allowAnalytics };

	$.ajaxHandler({
		"data"	: data,
		"url"	: "/ajax/setCookieStatus/"
	});
}

function confirmStopPos(posID) {
    $.confirm({
        title: "Dauerschein kündigen",
        content: "Bitte bestätigen Sie die Kündigung Ihres Dauerscheins.",
        buttons: {
            ok: function () {},
            schliessen: function () {}
        },
        onAction: function (btnName) {
            switch(btnName) {
                case "ok":
                    location.href = "/konto/stop_subscription_by_pos?id=" + posID;
                    break;
                default:
                    console.log("Der Vorgang wurde nicht bestätigt.");
            }
        }
    });
}

var dropdownPreviousValue;

function initializeAddressBindings() {
	// Postleitzahl Eingabe
	$("#zip_code").on("focusout keyup", function(e) {

		var cityDropdown = $('#city');
		var streetDropdown = $('#street');
		var numberField = $("#house_number");

		if($(this).val().match(/^[0-9]{5}/)){
			var resultStadt = $.ajaxHandler({
				"data" 				: {plz: $(this).val()},
				"url" 				: "/ajax/getOrteByPLZ/",
				"async"             : false
			});

			var countedOrte = resultStadt.result.ORTE.length;
			var oneItemDirectSelect = false;

			if(resultStadt.success) {
				cityDropdown.find('option').not(":first").remove()
				$.each(resultStadt.result.ORTE, function( index, value ) {
					if(countedOrte == 1){
						oneItemDirectSelect = true;
					}

					cityDropdown.prop('disabled', false);
					cityDropdown.append($('<option>', {
						"value" 		: value.ORT,
						"text" 			: value.ORT,
						"data-id" 		: value.ID,
						"data-alort" 	: value.ALORT,
						"selected" 		: oneItemDirectSelect
					}));
				});

				if(oneItemDirectSelect == true) {
					cityDropdown.trigger('change');
					streetDropdown.siblings('select').select2('open')
				} else {
					cityDropdown.focus();
				}
			}
		} else {
			cityDropdown.find('option').not(":first").remove();
			cityDropdown.prop('disabled', true);
			streetDropdown.find('option').not(":first").remove();
			streetDropdown.prop('disabled', true);
			numberField.prop('disabled', true).val("");
		}
	});

	// Stadt Auswwahl
	var autoStep = false;

	$("#city").change(function(e) {
		console.log("City Change");
		if(dropdownPreviousValue == this.value) {
			return false;
		}

		var streetDropdown = $('#street');
		var numberField = $("#house_number");
		var idOrt = $("#city").find(':selected').data('id');
		var alort = $("#city").find(':selected').data('alort');

		var resultStreet = $.ajaxHandler({
			"data" 				: {alort: alort, idOrt : idOrt},
			"url" 				: "/ajax/getOrteStrassen/",
			"async"             : false
		});

		if(resultStreet.success) {
			streetDropdown.find('option').not(":first").remove()
			streetDropdown.append($('<option>', {
				"value" 		: "stopTab",
				"text" 			: "",
			}));
			$.each(resultStreet.result.strassen, function( index, value ) {
				streetDropdown.append($('<option>', {
					"value" : value,
					"text" 	: value
				}));
			})

			streetDropdown.prop('disabled', false);
			autoStep = true;
			streetDropdown.focus();
			numberField.prop('disabled', true).val("");
		}
	});

	$("#city").on('select2:closing', function (e) {
		console.log(e);
		var highlightedOption = $(this).data('select2').$dropdown.find('.select2-results__option--highlighted');
		if(highlightedOption && highlightedOption.text() != $(this).val()) {
			$("#city").val(highlightedOption.text()).trigger('change');
		}
	});

	// Strasse Auswahl
	$("#street").change(function() {
		if($(this).val()) {
			autoStep = false;
		}

		if(autoStep == false) {
			$("#house_number").prop('disabled', false).val("").focus();
		}

		autoStep = false;
	})

	$("#street").select2().on("select2:close", function(e) {
		$('#house_number').focus().select();
	});

	$('#street').on('select2:closing', function () {
		console.log("Street selected");
		var highlightedOption = $(this).data('select2').$dropdown.find('.select2-results__option--highlighted');
		if(highlightedOption) {
			$("#street").val(highlightedOption.text()).trigger('change');
		}
	});
}

function updateCustomerAddress(body) {
	var result = $.ajaxHandler({
		"data" 				: {body: body},
		"url" 				: "/ajax/updateCustomerAddressData/",
		"async"             : false
	});

	return result;
}

function updateCustomerPhoneData(body) {
	var result = $.ajaxHandler({
		"data" 				: {body: body},
		"url" 				: "/ajax/updateCustomerPhoneData/",
		"async"             : false
	});

	return result;
}

function updateCustomerMobileData(body) {
	var result = $.ajaxHandler({
		"data" 				: {body: body},
		"url" 				: "/ajax/updateCustomerMobileData/",
		"async"             : false
	});

	return result;
}

function updateCustomerBankAccount(body) {
	var result = $.ajaxHandler({
		"data" 				: {body: body},
		"url" 				: "/ajax/updateCustomerBankAccount/",
		"async"             : false
	});

	return result;
}

function updateCustomerPreferedPaymentMethod(body) {
	var result = $.ajaxHandler({
		"data" 				: {body: body},
		"url" 				: "/ajax/updateCustomerPreferedPaymentMethod/",
		"async"             : false
	});

	return result;
}

function redirectOnLogout() {
    // check isLoggedIn via Ajax
    var result = $.ajaxHandler({
        "data": {},
        "url": "/ajax/isLoggedIn/",
        "async" : false
    });

    if(result == false) {
        location.href = "konto/login";

		return false;
    }

    return true;
}

function maskBankAccount(param) {
    if (typeof param !== "string") {
        throw new Error("Parameter must be a string");
    }

    const length = param.length;
    let hidden = "x".repeat(length);

    if (length > 4) {
        hidden = hidden.slice(0, length - 4) + param.slice(-4);
    }

    return hidden;
}

if($("#openBlackWeekBanner").length) {
	openAktionModal("BlackWeeks","spielgemeinschaften/popup_blackweek");
}

$("#checkbox-social").on("click", function() {
	if($("#checkbox-social").prop('checked')) {
		if(!$("#checkbox-ga").prop('checked')) {
			$("#checkbox-ga").prop( "disabled", true );
		}
		$("#checkbox-ga").prop( "checked", true );
	} else {
		if($("#checkbox-ga").prop( "disabled")) {
			$("#checkbox-ga").prop( "checked", false );
			$("#checkbox-ga").prop( "disabled", false );
		}
	}
});

$("#checkbox-ga").on("click", function() {
	if(!$("#checkbox-ga").prop('checked') && $("#checkbox-social").prop('checked')) {
		$("#checkbox-ga").prop( "checked", true );
		$("#checkbox-ga").prop( "disabled", true );
	}
});